import { Component, computed, input, output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

export type ButtonVariant = 'primary' | 'secondary';
export type ButtonType = 'button' | 'submit' | 'reset';
export type ButtonSize = 'small' | 'medium' | 'large';

@Component({
	selector: 'lvr-button',
	imports: [MatButton, MatProgressSpinner, MatIcon],
	templateUrl: './lvr-button.html',
	styleUrl: './lvr-button.scss',
})
export class LvrButton {
	public readonly variant = input<ButtonVariant>('primary');
	public readonly label = input.required<string>();
	public readonly icon = input<string | null>(null);
	public readonly disabled = input(false);
	public readonly loading = input(false);
	public readonly loadingLabel = input<string | null>(null);
	public readonly ariaLabel = input<string | null>(null);
	public readonly type = input<ButtonType>('button');
	public readonly size = input<ButtonSize>('medium');

	public readonly clicked = output<MouseEvent>();

	public readonly materialAppearance = computed<'filled' | 'outlined'>(() =>
		this.variant() === 'primary' ? 'filled' : 'outlined',
	);

	public readonly isDisabled = computed(() => this.disabled() || this.loading());

	public readonly computedAriaLabel = computed(() => this.ariaLabel() ?? this.loadingLabel() ?? this.label());

	public onClick(event: MouseEvent): void {
		if (this.isDisabled()) {
			event.preventDefault();
			event.stopPropagation();
			return;
		}

		this.clicked.emit(event);
	}
}
